<template>
  <div class="tutorial-hub">
    <section class="tutorial-hub__intro section">
      <div class="container">
        <h1 class="title tutorial-hub__page-title">
          {{ $t("tutorialsPage.pageTitle") }}
        </h1>
      </div>
    </section>
    <section class="tutorial-hub__grid-section section">
      <div class="container">
        <div class="columns is-multiline">
          <div class="column is-half-tablet is-half-desktop">
            <article class="tutorial-hub-card">
              <div class="tutorial-hub-card__top">
                <div class="tutorial-hub-card__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8 3h6l5 5v13a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"
                    />
                    <path d="M14 3v5h5" />
                    <path d="M9 12h6M9 16h6M9 20h4" />
                  </svg>
                </div>
                <span class="tutorial-hub-card__badge">{{
                  $t("tutorialsPage.sm5.badge")
                }}</span>
              </div>
              <h2 class="tutorial-hub-card__heading">
                {{ $t("tutorialsPage.sm5.title") }}
              </h2>
              <p class="tutorial-hub-card__desc">
                {{ $t("tutorialsPage.sm5.description") }}
              </p>
              <a
                class="tutorial-hub-card__cta"
                :href="$localized('shademotion5tutorial')"
                target="_blank"
                rel="noopener noreferrer"
                @click="$track('SM-Tutorials', 'tutorial-open', 'SM5-PDF')"
              >
                {{ $t("tutorialsPage.openTutorial") }} →
              </a>
            </article>
          </div>
          <div class="column is-half-tablet is-half-desktop">
            <article class="tutorial-hub-card">
              <div class="tutorial-hub-card__top">
                <div class="tutorial-hub-card__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <polygon points="12,3 20,8 20,16 12,21 4,16 4,8" />
                  </svg>
                </div>
                <span
                  class="tutorial-hub-card__badge tutorial-hub-card__badge--new"
                  >{{ $t("tutorialsPage.sm6.badge") }}</span
                >
              </div>
              <h2 class="tutorial-hub-card__heading">
                {{ $t("tutorialsPage.sm6.title") }}
              </h2>
              <p class="tutorial-hub-card__desc">
                {{ $t("tutorialsPage.sm6.description") }}
                <span
                  v-if="sm6EnglishPdfNote"
                  class="tutorial-hub-card__lang-note"
                >
                  {{ sm6EnglishPdfNote }}
                </span>
              </p>
              <a
                class="tutorial-hub-card__cta"
                :href="$localized('shademotion6tutorial')"
                target="_blank"
                rel="noopener noreferrer"
                @click="$track('SM-Tutorials', 'tutorial-open', 'SM6-PDF')"
              >
                {{ $t("tutorialsPage.openTutorial") }} →
              </a>
            </article>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "TutorialsHub",
  computed: {
    sm6EnglishPdfNote() {
      const loc = this.$i18n.locale;
      if (loc === "es" || loc === "en") {
        return "";
      }
      return this.$t("tutorialsPage.sm6.englishPdfNote");
    },
  },
};
</script>
